export function feedbackTitleHelper(arg) {
    return {
        addTitle: `Ajout ${arg}`,
        editTitle: `Modification ${arg}`,
        deleteTitle: `Suppression ${arg}`,
    }
}
